export default "__VITE_ASSET__BKgMr1GJ__"